import script from "./equipmentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./equipmentDetail.vue?vue&type=script&setup=true&lang=js"

import "./equipmentDetail.vue?vue&type=style&index=0&id=9074b4fa&lang=less"

const __exports__ = script;

export default __exports__